<template>
  <div class="aggregate">
    <div style="margin:18px 0">
      <Breadcrumb :breadcrumb="breadcrumb" />
    </div>
    <div style="padding:20px 29px 20px;background: #fff;border-radius:2px;">
      <cardTitle title="个案帮扶" />
      <div class="tubiao-bigview">
        <div id="tubiao1" class="tubiao"></div>
        <div id="tubiao2" class="tubiao"></div>
        <div id="tubiao4" class="tubiao"></div>
        <div id="tubiao5" class="tubiao"></div>
        <div id="tubiao6" class="tubiao" v-if="municipal_tree_level === '0'"></div>
        <div id="tubiao7" class="tubiao bingtutubiao"></div>
        <div id="tubiao8" class="tubiao bingtutubiao"></div>
        <div id="tubiao9" class="tubiao bingtutubiao"></div>
        <div id="tubiao10" class="tubiao bingtutubiao"></div>
        <div id="tubiao11" class="tubiao bingtutubiao"></div>
        <div id="tubiao12" class="tubiao bingtutubiao"></div>
        <div id="tubiao13" class="tubiao bingtutubiao"></div>
        <div id="tubiao14" class="tubiao bingtutubiao"></div>
      </div>
    </div>

    <div style="padding:20px 29px 20px;background: #fff;border-radius:2px;margin-top: 18px">
      <cardTitle title="项目帮扶" />
      <div class="tubiao-bigview">
        <div id="xm_tubiao1" class="tubiao"></div>
        <div id="xm_tubiao2" class="tubiao"></div>
        <div id="xm_tubiao3" class="tubiao bingtutubiao"></div>
        <div id="xm_tubiao4" class="tubiao bingtutubiao"></div>
      </div>
    </div>
  </div>
</template>

<script>

import cardTitle from '../components/cardTitle'
import Breadcrumb from '@/components/breadcrumb'
import * as echarts from 'echarts'
import request from '@/utils/request'

var baseOption = {
  title: {
    text: '个案帮扶人数',
    textStyle: {
      align: 'left',
      color: '#414141',
      fontSize: 14
    }
  },
  tooltip: {},
  xAxis: {
    data: []
  },
  yAxis: {},
  series: [
    {
      name: '帮扶人次',
      type: 'bar',
      barWidth: 20,
      data: []
    }, {
      name: '帮扶人次',
      type: 'line',
      // symbol: 'circle', // 标记的图形为实心圆
      itemStyle: {
        // 折线拐点标志的样式
        color: '#058cff'
      },
      smooth: true,
      data: []
    }
  ]
}

var baseOption2 = {
  title: {
    text: '当年个案数据',
    textStyle: {
      align: 'left',
      color: '#414141',
      fontSize: 14
    }
  },
  tooltip: {},
  xAxis: {
    axisLabel: {
      interval: 0,
      rotate: 30
    },
    textStyle: {
      fontSize: '11'
    },
    data: ['黄浦区', '徐汇区', '长宁区', '静安区', '普陀区', '虹口区', '杨浦区', '闵行区', '宝山区', '嘉定区', '浦东新区', '金山区', '松江区', '奉贤区', '青浦区', '崇明区', '光明益群（农场）']
  },
  yAxis: [
    {
      type: 'value',
      name: '人次',
      axisLabel: {
        formatter: '{value} 人'
      }
    },
    {
      type: 'value',
      name: '金额',
      axisLabel: {
        formatter: '{value} 元'
      }
    }
  ],
  series: [
    {
      name: '人次',
      type: 'bar',
      barWidth: 10,
      data: ['5', '6', '12', '33', '4', '8', '3', '7', '11', '12', '23', '1', '1', '4', '2', '22', '11']
    }, {
      name: '当年个案资金',
      type: 'bar',
      barWidth: 10,
      data: ['5.23', '6.24', '12.21', '33.12', '40.33', '80', '35', '74', '110', '121', '43', '12', '71', '54', '12', '22', '111'],
      yAxisIndex: 1
    }, {
      name: '去年同期个案数',
      type: 'bar',
      barWidth: 10,
      data: ['15', '16', '12', '23', '24', '38', '23', '27', '11', '12', '23', '14', '12', '14', '12', '22', '11']
    }, {
      name: '去年同期个案资金',
      type: 'bar',
      barWidth: 10,
      data: ['15.23', '16.24', '22.21', '23.12', '10.33', '30', '15', '24', '56', '45', '13', '12', '21', '34', '32', '22', '91'],
      yAxisIndex: 1
    }
  ]
}

var bingtuBaseOption = {
  title: {
    text: '家庭类别-历年',
    subtext: '',
    left: 'left',
    textStyle: {
      align: 'left',
      color: '#414141',
      fontSize: 14
    }
  },
  tooltip: {
    trigger: 'item',
    formatter: '{a} <br/>{b} : {c} ({d}%)'
  },
  legend: {
    top: 'bottom',
    padding: [
      20, // 上
      0, // 右
      0, // 下
      0 // 左
    ]
  },
  toolbox: {
    show: true,
    feature: {
      saveAsImage: { show: true }
    }
  },
  series: [
    {
      name: '统计个案数',
      type: 'pie',
      radius: [50, 200],
      center: ['50%', '50%'],
      roseType: 'area',
      itemStyle: {
        borderRadius: 8
      },
      data: [
        { value: 40, name: '名称1' },
        { value: 38, name: '名称2' },
        { value: 32, name: '名称3' },
        { value: 30, name: '名称4' }
      ]
    }
  ]
}

export default {
  name: 'Index',
  components: {
    cardTitle,
    Breadcrumb
  },
  data() {
    return {
      breadcrumb: [
        {
          // 面包屑
          title: '综合帮扶',
          path: ''
        },
        {
          title: '帮扶数据汇总',
          path: ''
        }
      ],
      nowYear: 2023,
      municipal_tree_level: ''
    }
  },
  created() { },
  mounted() {
    const userInfo = this.$store.getters.userInfo ? this.$store.getters.userInfo.user : {}
    this.municipal_tree_level = userInfo.municipal_tree_level
    var date = new Date()
    this.nowYear = date.getFullYear() // 获取当前年份
    this.chushihuaData()
  },
  methods: {
    // 获取图表数据
    chushihuaData() {
      request({
        url: `/auth/online/getIndividualByYear`,
        method: 'get',
        params: {
          type: 0,
          startYear: this.nowYear - 5,
          endYear: this.nowYear
        }
      }).then((ret) => {
        this.tubiaoInit1(ret)
      })
      request({
        url: `/auth/online/getIndividualByYear`,
        method: 'get',
        params: {
          type: 1,
          startYear: this.nowYear - 5,
          endYear: this.nowYear
        }
      }).then((ret) => {
        this.tubiaoInit2(ret)
      })
      request({
        url: `/auth/online/getIndividualByMonth`,
        method: 'get',
        params: {
          type: 0,
          year: this.nowYear
        }
      }).then((ret) => {
        this.tubiaoInit4(ret)
      })

      request({
        url: `/auth/online/getIndividualByMonth`,
        method: 'get',
        params: {
          type: 1,
          year: this.nowYear
        }
      }).then((ret) => {
        this.tubiaoInit5(ret)
      })

      if (this.municipal_tree_level === '0') {
        request({
          url: `/auth/online/getIndividualByDistrict`,
          method: 'get',
          params: {}
        }).then((ret) => {
          this.tubiaoInit6(ret)
        })
      }

      request({
        url: `/auth/online/getIndividualGroupByType`,
        method: 'get',
        params: {
          groupType: 0, // 0 家庭类别 1 年龄结构 2 帮扶类别
          yearType: 0 // 0 历年 1 当年
        }
      }).then((ret) => {
        this.tubiaoInit7(ret)
      })

      request({
        url: `/auth/online/getIndividualGroupByType`,
        method: 'get',
        params: {
          groupType: 0, // 0 家庭类别 1 年龄结构 2 帮扶类别
          yearType: 1 // 0 历年 1 当年
        }
      }).then((ret) => {
        this.tubiaoInit8(ret)
      })

      request({
        url: `/auth/online/getIndividualGroupByType`,
        method: 'get',
        params: {
          groupType: 1, // 0 家庭类别 1 年龄结构 2 帮扶类别
          yearType: 0 // 0 历年 1 当年
        }
      }).then((ret) => {
        this.tubiaoInit9(ret)
      })

      request({
        url: `/auth/online/getIndividualGroupByType`,
        method: 'get',
        params: {
          groupType: 1, // 0 家庭类别 1 年龄结构 2 帮扶类别
          yearType: 1 // 0 历年 1 当年
        }
      }).then((ret) => {
        this.tubiaoInit10(ret)
      })

      request({
        url: `/auth/online/getIndividualGroupByType`,
        method: 'get',
        params: {
          groupType: 2, // 0 家庭类别 1 年龄结构 2 帮扶类别
          yearType: 0 // 0 历年 1 当年
        }
      }).then((ret) => {
        this.tubiaoInit11(ret)
      })

      request({
        url: `/auth/online/getIndividualGroupByType`,
        method: 'get',
        params: {
          groupType: 2, // 0 家庭类别 1 年龄结构 2 帮扶类别
          yearType: 1 // 0 历年 1 当年
        }
      }).then((ret) => {
        this.tubiaoInit12(ret)
      })

      request({
        url: `/auth/online/getIndividualGroupByFund`,
        method: 'get',
        params: {
          yearType: 0 // 0 历年 1 当年
        }
      }).then((ret) => {
        this.tubiaoInit13(ret)
      })

      request({
        url: `/auth/online/getIndividualGroupByFund`,
        method: 'get',
        params: {
          yearType: 1 // 0 历年 1 当年
        }
      }).then((ret) => {
        this.tubiaoInit14(ret)
      })

      // 项目帮扶
      request({
        url: `/auth/online/getProjectByYear`,
        method: 'get',
        params: {
          type: 0, // 0、覆盖人次 1、资金汇总
          startYear: this.nowYear - 5,
          endYear: this.nowYear
        }
      }).then((ret) => {
        this.xm_tubiaoInit1(ret)
      })

      request({
        url: `/auth/online/getProjectByYear`,
        method: 'get',
        params: {
          type: 1, // 0、覆盖人次 1、资金汇总
          startYear: this.nowYear - 5,
          endYear: this.nowYear
        }
      }).then((ret) => {
        this.xm_tubiaoInit2(ret)
      })

      request({
        url: `/auth/online/getProjectGroupByType`,
        method: 'get',
        params: {
          groupType: 0,
          yearType: 0,
          countType: 0
        }
      }).then((ret) => {
        this.xm_tubiaoInit3(ret)
      })

      request({
        url: `/auth/online/getProjectGroupByType`,
        method: 'get',
        params: {
          groupType: 0,
          yearType: 0,
          countType: 1
        }
      }).then((ret) => {
        this.xm_tubiaoInit4(ret)
      })
    },
    tubiaoInit1(result) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('tubiao1'))
      var option = baseOption

      option.title.text = '人次汇总-历年'
      option.xAxis.data = result.xvalueList
      option.series[0].name = '帮扶人次'
      option.series[0].data = result.yvalueList
      option.series[1].name = '帮扶人次'
      option.series[1].data = result.yvalueList
      // 绘制图表
      myChart.setOption(option)
    },
    tubiaoInit2(result) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('tubiao2'))
      var option = baseOption

      option.title.text = '资金汇总-历年'
      option.xAxis.data = result.xvalueList
      option.series[0].name = '资金数'
      option.series[0].data = result.yvalueList
      option.series[1].name = '资金数'
      option.series[1].data = result.yvalueList
      // 绘制图表
      myChart.setOption(option)
    },

    tubiaoInit4(result) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('tubiao4'))
      var option = baseOption

      option.title.text = '人次汇总-当年'
      option.xAxis.data = result.xvalueList
      option.series[0].name = '帮扶人次'
      option.series[0].data = result.yvalueList
      option.series[1].name = '帮扶人次'
      option.series[1].data = result.yvalueList
      // 绘制图表
      myChart.setOption(option)
    },
    tubiaoInit5(result) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('tubiao5'))
      var option = baseOption
      option.title.text = '资金汇总-当年'
      option.xAxis.data = result.xvalueList
      option.series[0].name = '资金数'
      option.series[0].data = result.yvalueList
      option.series[1].name = '资金数'
      option.series[1].data = result.yvalueList
      // 绘制图表
      myChart.setOption(option)
    },
    tubiaoInit6(result) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('tubiao6'))
      var option = baseOption2
      // console.log('xdata', JSON.stringify(result.xvalueList))
      option.xAxis.data = result.xvalueList
      option.series[0].data = result.yvalueList
      option.series[1].data = result.yvalueList2
      option.series[2].data = result.yvalueList3
      option.series[3].data = result.yvalueList4
      // 绘制图表
      myChart.setOption(option)
    },
    tubiaoInit7(result) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('tubiao7'))
      var option = bingtuBaseOption
      option.title.text = '家庭类别-历年'
      option.series[0].name = '统计个案数'
      result.map((item, index) => {
        if (item.value === '0') {
          item.itemStyle = {
            borderColor: 'rgba(50,123,250,0.2)',
            borderWidth: 2
          }
        }
        return item
      })
      option.series[0].data = result
      // 绘制图表
      myChart.setOption(option)
    },
    tubiaoInit8(result) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('tubiao8'))
      var option = bingtuBaseOption
      option.title.text = '家庭类别-当年'
      option.series[0].name = '统计个案数'
      result.map((item, index) => {
        if (item.value === '0') {
          item.itemStyle = {
            borderColor: 'rgba(50,123,250,0.2)',
            borderWidth: 2
          }
        }
        return item
      })
      option.series[0].data = result
      // 绘制图表
      myChart.setOption(option)
    },
    tubiaoInit9(result) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('tubiao9'))
      var option = bingtuBaseOption
      option.title.text = '年龄结构-历年'
      option.series[0].name = '统计个案数'
      result.map((item, index) => {
        if (item.value === '0') {
          item.itemStyle = {
            borderColor: 'rgba(50,123,250,0.2)',
            borderWidth: 2
          }
        }
        return item
      })
      option.series[0].data = result
      // 绘制图表
      myChart.setOption(option)
    },
    tubiaoInit10(result) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('tubiao10'))
      var option = bingtuBaseOption
      option.title.text = '年龄结构-当年'
      option.series[0].name = '统计个案数'
      result.map((item, index) => {
        if (item.value === '0') {
          item.itemStyle = {
            borderColor: 'rgba(50,123,250,0.2)',
            borderWidth: 2
          }
        }
        return item
      })
      option.series[0].data = result
      // 绘制图表
      myChart.setOption(option)
    },
    tubiaoInit11(result) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('tubiao11'))
      var option = bingtuBaseOption
      option.title.text = '帮扶类别-历年'
      option.series[0].name = '统计个案数'
      result.map((item, index) => {
        if (item.value === '0') {
          item.itemStyle = {
            borderColor: 'rgba(50,123,250,0.2)',
            borderWidth: 2
          }
        }
        return item
      })
      option.series[0].data = result
      // 绘制图表
      myChart.setOption(option)
    },
    tubiaoInit12(result) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('tubiao12'))
      var option = bingtuBaseOption
      option.title.text = '帮扶类别-当年'
      option.series[0].name = '统计个案数'
      result.map((item, index) => {
        if (item.value === '0') {
          item.itemStyle = {
            borderColor: 'rgba(50,123,250,0.2)',
            borderWidth: 2
          }
        }
        return item
      })
      option.series[0].data = result
      // 绘制图表
      myChart.setOption(option)
    },
    tubiaoInit13(result) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('tubiao13'))
      var option = bingtuBaseOption
      option.title.text = '帮扶金额-历年'
      option.series[0].name = '统计个案数'
      result.map((item, index) => {
        if (item.value === '0') {
          item.itemStyle = {
            borderColor: 'rgba(50,123,250,0.2)',
            borderWidth: 2
          }
        }
        return item
      })
      option.series[0].data = result
      // 绘制图表
      myChart.setOption(option)
    },
    tubiaoInit14(result) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('tubiao14'))
      var option = bingtuBaseOption
      option.title.text = '帮扶金额-当年'
      option.series[0].name = '统计个案数'
      result.map((item, index) => {
        if (item.value === '0') {
          item.itemStyle = {
            borderColor: 'rgba(50,123,250,0.2)',
            borderWidth: 2
          }
        }
        return item
      })
      option.series[0].data = result
      // 绘制图表
      myChart.setOption(option)
    },

    /** ***********项目帮扶****************** */
    xm_tubiaoInit1(result) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('xm_tubiao1'))
      var option = baseOption

      option.title.text = '覆盖人次-历年'
      option.xAxis.data = result.xvalueList
      option.series[0].name = '覆盖人次'
      option.series[0].data = result.yvalueList
      option.series[1].name = '覆盖人次'
      option.series[1].data = result.yvalueList
      // 绘制图表
      myChart.setOption(option)
    },
    xm_tubiaoInit2(result) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('xm_tubiao2'))
      var option = baseOption

      option.title.text = '资金汇总-历年'
      option.xAxis.data = result.xvalueList
      option.series[0].name = '资金'
      option.series[0].data = result.yvalueList
      option.series[1].name = '资金'
      option.series[1].data = result.yvalueList
      // 绘制图表
      myChart.setOption(option)
    },
    xm_tubiaoInit3(result) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('xm_tubiao3'))
      var option = bingtuBaseOption
      option.title.text = '帮扶类别覆盖人次-历年'
      option.series[0].name = '覆盖人次'
      // eslint-disable-next-line camelcase
      var cache_result = result.filter((item, index) => {
        if (item.name) {
          if (item.value === '0' || item.value === '0.0') {
            item.itemStyle = {
              borderColor: 'rgba(50,123,250,0.2)',
              borderWidth: 2
            }
          }
          return item
        }
      })
      // eslint-disable-next-line camelcase
      option.series[0].data = cache_result
      // 绘制图表
      myChart.setOption(option)
    },
    xm_tubiaoInit4(result) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('xm_tubiao4'))
      var option = bingtuBaseOption
      option.title.text = '帮扶类别项目个数-历年'
      option.series[0].name = '项目个数'

      // eslint-disable-next-line camelcase
      var cache_result = result.filter((item, index) => {
        if (item.name) {
          if (item.value === '0' || item.value === '0.0') {
            item.itemStyle = {
              borderColor: 'rgba(50,123,250,0.2)',
              borderWidth: 2
            }
          }
          return item
        }
      })
      // eslint-disable-next-line camelcase
      option.series[0].data = cache_result
      // 绘制图表
      myChart.setOption(option)
    }
  }
}
</script>

<style scoped lang="less">
.tubiao-bigview {
  margin-top: 18px;
  // display: flex;
  // justify-content: space-between;
  .tubiao {
    width: 100%;
    height: 450px;
  }
  .bingtutubiao {
    margin-top: 20px;
    height: 500px;
  }
}
</style>
